const MUIModalButtonStyles = {
    backgroundColor: '#118ABD',
    color: '#FFFFFF',
    '&:hover': {
        backgroundColor: '#0F7AB0',
    },
    padding: '8px 24px',
    minHeight: '40px',
};

export default MUIModalButtonStyles;
